import { ArrowUpRight } from "@phosphor-icons/react";
import { FIRM } from "../../lib/firm";
import { trackEvent } from "../../lib/analytics";

export default function NextStep() {
  return (
    <section
      id="next-step"
      data-testid="next-step-section"
      className="py-24 lg:py-32 bg-deep-teal"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="text-xs tracking-overline uppercase font-semibold text-accent-gold">
                Next Step
              </span>
              <span className="h-px w-10 bg-accent-gold/60" />
            </div>
            <h2
              className="font-serif font-light leading-[1.04] tracking-tight"
              style={{ fontSize: "clamp(2.25rem, 4.6vw, 4rem)" }}
              data-testid="next-step-headline"
            >
              See the size of your retirement tax exposure
              <span className="italic"> before you commit.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-cream/85 text-base leading-relaxed">
              The Retirement Tax Risk Analysis is a diagnostic — not a pitch.
              Most clients discover six- or seven-figure liabilities they did
              not know they had.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-5">
              <a
                href={FIRM.calendly15}
                target="_blank"
                rel="noreferrer"
                onClick={() =>
                  trackEvent("calendly_click_15min", {
                    meta: { source: "next_step" },
                  })
                }
                data-testid="next-step-primary-cta"
                className="group inline-flex items-center gap-3 px-7 py-4 bg-accent-gold !text-white text-xs tracking-overline uppercase font-medium hover:bg-accent-gold-hover transition-all"
              >
                Schedule Your Risk Analysis
                <ArrowUpRight
                  size={16}
                  weight="light"
                  className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                />
              </a>
              <a
                href={FIRM.calendly15}
                target="_blank"
                rel="noreferrer"
                onClick={() =>
                  trackEvent("calendly_click_15min", {
                    meta: { source: "next_step_secondary" },
                  })
                }
                data-testid="next-step-secondary-cta"
                className="inline-flex items-center gap-2 text-sm editorial-link"
                style={{ color: "var(--cream)" }}
              >
                Or book a 15-min intro call
                <ArrowUpRight size={16} weight="light" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
